import { config } from '@/config';

export const link = {
  // Themes list URL — Shopline tự route merchant tới đúng editor (sline cho OS 3.0, handlebars cho OS 2.x).
  // Chỉ dùng làm fallback khi backend `deepLinkUrl` chưa resolve; backend trả URL trực tiếp tới App Embeds panel.
  isOpenAppEmbedUrl: `https://${config.shop}.myshopline.com/admin/online-store/themes`,
};
export const urlRickScore = 'https://docs.ipblocker.io/getting-started/visitor-analytics#risk-score';
